import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

export function useUser() {
  const { user } = useUserStore()

  // User is always logged in and always have an e-mail
  return {
    email: user.value.email || '',
    firstName: user.value.firstName || '',
    lastName: user.value.lastName || '',
    phone: { dial: user.value.phone?.dial, phone: user.value.phone?.phone },
  }
}
